import React, { useState, useEffect } from 'react'
import SponsorAgreementP1 from './components/Page1';
import FinalFormP from './components/FinalFormP';
import { useSelector } from "react-redux";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
import { getAggreementFormReview, getApplicationID } from "../../../auth/services/apiCalling"
import { sponsorRegistration } from '../../../../core/data/json/contractFarming';
interface ConditionItem {
  itemNo: string;
  item: string;
  isBlankExist: boolean;
  blank: any[];
  subItem: {
    subitemNo: string;
    subItemSno: string;
    subItemVal: string;
  }[];
  isTableExist: boolean;
  tableItems: any[];
  isUpdated?: boolean;
  status?: 'normal' | 'deleted' | 'updated' | 'added'; // To change conditons 
}
const SponsorAgreement = () => {
  const [step, setStep] = useState<number>(1);
  const [app_id, setApp_id] = useState<any>();
  const [reviewedData1, setreviewedData1] = useState<any>();
  const token = useSelector((state: any) => state.auth.token);
  const [isApproved, setIsApproved] = useState<any>();
  const [isload, setIsLoad] = useState<any>(false);
  const [conditionsData, setConditionsData] = useState<ConditionItem[]>(sponsorRegistration);

  const getApp_ID = async () => {
    setIsLoad(true);
    try {
      const res = await getApplicationID(token);
      setIsApproved(res?.success);
     
      if (res?.success == true) {
       
        await formReviewDetails(res?.data?.applicationId);
        setApp_id(res?.data)
      } else {
        toast.error(res?.message, { position: "top-right" });
      }
    } catch (error) {
      
      toast.error("Something went wrong while fetching App ID.", {
        position: "top-right",
      });
    } finally {
      setIsLoad(false); // 🔹 Stop loading
    }
  }

  const formReviewDetails = async (id: any) => {

    const resp = await getAggreementFormReview(token, id);
    if (resp?.success == true) {
      
      setreviewedData1(resp?.data)
    } else {
      toast.error(resp?.message, { position: "top-right" });
    }
  }
  useEffect(() => {
    getApp_ID();
  }, [step])


  const handleNext = (): void => {
    if (step < 3) setStep(step + 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });

  };

  const handleBack = (): void => {
    if (step > 1) setStep(step - 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });

  };

  return (
    <div>

      <div className="page-wrapper">
        {step === 1 && app_id && (
          <SponsorAgreementP1
            conditionsData={conditionsData}
            setConditionsData={setConditionsData}
            onNext={handleNext}
            applicationIdData={app_id}
            reviewedData1={reviewedData1}
            isEnable1={{}}
            appdata1={{}}
          />)}

        {isload &&
          <div className="loader-container d-flex flex-column justify-content-center align-items-center" style={{ height: "100vh" }}>
            <i className="fa fa-spinner fa-spin fa-3x mb-2"></i>
            <h6 >Loading Data...</h6>
          </div>
        }

        {
          (step === 1 && isApproved == false && (
            <div className="d-flex flex-column justify-content-center align-items-center py-5 gap-3">
              <span className="text-danger fw-semibold">You are not registered. Please register to proceed.</span>
              <a href="/sponsor-registration" className="btn btn-primary">Go to Registration</a>
            </div>
          ))
        }
        {step === 2 && (
          <FinalFormP

          />)}
        {/* {step === 2 && (
        <SponsorRegistrationP2
          onBack={handleBack}
          onNext={handleNext}
        />)}

       
        {step === 3 && (
          <SponsorRegistrationP3 />
        )} */}

      </div>
      <ToastContainer />
    </div>
  )
}

export default SponsorAgreement